<template lang="pug">
transition-group.k-actions.actions( name='fade' tag='div' )
  template( v-for='( action ) in actions' )
    w-btn(
      v-if='actionPasses( action ) && ( action.icon || action.label )'
      :key='action.name' 
      @click.prevent='doAction( action )'
    )
      span( v-if=`action.label && (type.startsWith( 'text' ))` )
        | {{ action.label }}
      component.icon(
        v-if=`icons[ action.icon ] && (type.match( 'icon' ))`
        :is='icons[ action.icon ]'
        :title='action.label' 
      )
      span( v-if=`action.label && type === 'icon-text'` )
        | {{ action.label }}

</template>

<script lang="js">
import { mapActions, mapGetters } from 'vuex'
import WBtn from '@/widgets/w-btn'
// import WBtnIcon from '@/widgets/w-btn-icon'

export default {
  name: 'ActionsBlock',
  mixins: [],
  components: { WBtn },
  props: {
    model: Object,
    item: Object,
    items: Array,
    actions: {
      type: Array,
      default: () => []
    },
    icons: {
      type: Object,
      default: () => ({})
    },
    type: {
      type: String,
      default: 'icon',
    },
    context: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
    }
  },
  created() {},
  mounted() {},
  methods: {
    ...mapActions([ 'openModal' ]),
    async doAction( action ) {
      if ( action.modal ) {
        this.openModal({ name: action.modal.component, data: action.modal.meta })
      } else if ( action.url ) {
      } else if ( action.dispatch ) {
        if ( this.items ) {
          await this.$store.dispatch( action.dispatch, {
            model: this.model,
            objects: this.items,
          })
        } else {
          await this.$store.dispatch( action.dispatch, {
            model: this.model,
            object: this.item,
          })
        }
        if ( action.refresh ) {
          this.$emit( 'refresh' )
        }
      } else if ( action.fn ) {
        if ( this.items ) {
          this.$emit( 'exec', { fn: action.fn, action, items: this.items })
        } else {
          this.$emit( 'exec', { fn: action.fn, action, item: this.item })
        }
      }
    },
    actionPasses( action ) {
      return !( 'if' in action ) || action.if
    }
  },
  computed: {}
}
</script>

<style lang="scss">
.k-actions {

}
</style>
